import { render, staticRenderFns } from "./backtop.vue?vue&type=template&id=caba5b60&scoped=true&"
import script from "./backtop.vue?vue&type=script&lang=ts&"
export * from "./backtop.vue?vue&type=script&lang=ts&"
import style0 from "./backtop.vue?vue&type=style&index=0&id=caba5b60&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caba5b60",
  null
  
)

export default component.exports